import Vue from 'vue';
import Router from 'vue-router';
import index from '@/views/index';
import home from '@/views/home';
import product from '@/views/product';
import service from '@/views/service';
import news from '@/views/news';
import newsDetail from '@/views/newsDetail';
import newsList from '@/views/newsList';
import about from '@/views/about';
import productinfo from '@/views/productinfo';
import mobileProductList from '@/views/mobileProductList';
import mobileScene from '@/views/mobileScene';
import productinfoA from '@/views/productinfoA';
import productinfoB from '@/views/productinfoB';
import ServicePlatform from '@/views/ServicePlatform';
import experience from '@/views/experience';
import developmenter from '@/views/developmenter';
import movingEnd from '@/views/movingEnd';

Vue.use(Router);

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      component: index,
      children:[
        {
          path: '/',
          name: 'home',
          component: home,
        },
        {
          path: '/en',
          name: 'home',
          component: home,
        },
        {
          path: '/product/:type/:value',
          name: 'product',
          component: product,
        },
        {
          path: '/mobileProductList/:type',
          name: 'mobileProductList',
          component: mobileProductList,
        },
        {
          path: '/mobileScene/:scene',
          name: 'mobileScene',
          component: mobileScene,
        },
        {
          path: '',
          // name: 'productinfo',
          component: productinfo,
          children:[
            {
              path:'/productinfoA/:id',
              name:"productinfoA",
              component:productinfoA
            },
            {
              path:'/productinfoB/:id',
              name:"productinfoB",
              component:productinfoB
            },
            {
              path:'/movingEnd/:id',
              name:"movingEnd",
              component:movingEnd
            }
          ],

        },
        {
          path: '/service',
          name: 'service',
          component: service,
        },
        {
          path: '/news',
          name: 'news',
          component: news,
          meta:{title:'新闻动态'}
        },
        {
          path: '/newsDetail',
          name: 'newsDetail',
          component: newsDetail,
          meta:{title:'详情'}
        },
        {
          path: '/newsDetail',
          name: 'newsDetail_en',
          component: newsDetail,
          meta:{title:'xiangqing'}
        },
        {
          path: '/newsList',
          name: 'newsList',
          component: newsList,
          meta:{title:'新闻列表'}
        },
        {
          path: '/newsList',
          name: 'newsList_en',
          component: newsList,
          meta:{title:'News list'}
        },
        {
          path: '/about',
          name: 'about',
          component: about,
        },
        {
          path: '/ServicePlatform',
          name: 'ServicePlatform',
          component: ServicePlatform,
        },
        {
          path: '/experience',
          name: 'experience',
          component: experience,
        },
        {
          path: '/developmenter',
          name: 'developmenter',
          component: developmenter,
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js